import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton, Modal } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const accountsModalStyles = {
    content: {
        width: "625px",
        padding: "0",
        maxHeight: "100%",
        display: "flex",
        flexDirection: "column",
    } as const,
};

const AccountItemLayout = css`
    display: inline-grid;
    grid-template-columns: minmax(232px, 1fr) minmax(232px, 1fr);
    column-gap: 16px;
    box-sizing: border-box;
    width: 100%;
    align-items: center;
`;

export const StyledAccountsListHeader = styled.div`
    padding: 8px 24px;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    background-color: ${colorsPalettes.carbon[25]};
    ${AccountItemLayout}
`;

export const StyledAccountsList = styled.div`
    overflow: auto;
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
`;

export const StyledAccountListItem = styled.div`
    padding: 30px 16px 16px 24px;
    background-color: ${colorsPalettes.carbon[0]};
    transition: background-color 0.2s ease-in-out;

    ${AccountItemLayout}
    &:not(:last-child) {
        border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    }

    &:hover {
        background-color: ${colorsPalettes.carbon[25]};
    }
`;

export const StyledCompanyName = styled(Text)`
    color: ${colorsPalettes.carbon[400]};
    margin-bottom: 4px;
`;

export const StyledAccountsExportPreviewContent = styled(Modal.Content)`
    padding: 16px 0 !important;
`;

export const StyledAccountControl = styled(Flex)<{ isNewAccount: boolean }>`
    min-width: 0;
    padding-right: ${({ isNewAccount }) => isNewAccount ? "0" : "40px"};
`;

export const StyledSelectWrap = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const StyledNewAccountInput = styled.input`
    box-sizing: border-box;
    width: 100%;
    height: 36px;
    padding: 0 12px;
    border: 1px solid ${colorsPalettes.midnight[50]};
    border-radius: 4px;
    background-color: ${colorsPalettes.carbon[0]};
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    outline: none;

    &:focus {
        border-color: ${colorsPalettes.blue[400]};
    }

    &::placeholder {
        color: ${colorsPalettes.carbon[300]};
    }
`;

export const StyledEditIconButton = styled(IconButton)`
    flex: 0 0 auto;
`;

export const StyledCheckIconButton = styled(IconButton)`
    flex: 0 0 auto;

    .SWReactIcons svg path {
        fill: ${colorsPalettes.mint[400]};
    }

    &:hover .SWReactIcons svg path {
        fill: ${colorsPalettes.mint[400]};
    }
`;
